import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import SelectLabels from "../../components/SelectLabelsPayMethod";

function PaymentMethod({
  setPayMethodModal,
  handlePaymentMethod,
  paymentType,
}) {
  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-4  my-12">
        <div className="flex justify-end">
          <CancelIcon
            onClick={() => setPayMethodModal(false)}
            className="cursor-pointer text-black mb-2"
          />
        </div>

        <div className="p-2 m-2">
          <SelectLabels
            //   previousValue={selectedCustomerId}
            categoryData={paymentType}
            text="Select Payment Method"
            valueKey="id"
            labelKey="method_name"
            onSelectChange={handlePaymentMethod}
          />
        </div>
      </div>
    </div>
  );
}

export default PaymentMethod;
